class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        //.then((response) => response.text())
        .then((response) => {
          if (!response.ok) {
            throw new Error('Cart drawer update failed: ' + response.status);
          }
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          //console.error(e);
          console.error('Cart drawer update error:', e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        //.then((response) => response.text())
        .then((response) => {
          if (!response.ok) {
            throw new Error('Cart items update failed: ' + response.status);
          }
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) {
            this.innerHTML = sourceQty.innerHTML;
          } else {
            console.error('Cart items element not found in response');
          }
        })
        .catch((e) => {
          //console.error(e);
          console.error('Cart items update error:', e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Cart update failed: ' + response.status);
        }
        return response.text();
      })
      .then((state) => {
        //const parsedState = JSON.parse(state);
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error('Failed to parse cart response:', e);
          console.error('Response text:', state);
          throw new Error('Invalid JSON response from cart update');
        }
        
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartWrapper = document.getElementById('main-cart-wrapper');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter){
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          cartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        }
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// 英語環境での配送オプションラベル書き換え機能
function replaceDeliveryLabelsForEnglish() {
  console.log('[DeliveryLabels] Function called');
  
  // HTMLのlang属性が'en'でない場合は処理しない
  if (document.documentElement.lang !== 'en') {
    console.log('[DeliveryLabels] Language is not "en", current lang:', document.documentElement.lang);
    return;
  }

  console.log('[DeliveryLabels] Language is "en", proceeding...');

  const ngcContainer = document.getElementById('_NGC_CFA');
  if (!ngcContainer) {
    console.log('[DeliveryLabels] #_NGC_CFA container not found');
    return;
  }

  console.log('[DeliveryLabels] #_NGC_CFA container found:', ngcContainer);

  // .ngc-note-attr-field内のラベルを英語に書き換え
  const noteAttrFields = ngcContainer.querySelectorAll('.ngc-note-attr-field > label');
  console.log('[DeliveryLabels] Found', noteAttrFields.length, 'label elements');
  
  // 順番に基づいて文言を設定（ハードコーディング）
  noteAttrFields.forEach((label, index) => {
    const originalText = label.textContent;
    console.log(`[DeliveryLabels] Label ${index + 1} original text:`, originalText);
    
    if (index === 0) {
      // 1つ目の.ngc-note-attr-field - 配送希望日
      label.textContent = 'PREFERRED DELIVERY DATE';
      console.log(`[DeliveryLabels] Label ${index + 1} changed to: PREFERRED DELIVERY DATE`);
    } else if (index === 1) {
      // 2つ目の.ngc-note-attr-field - 配送希望時間
      label.textContent = 'PREFERRED DELIVERY TIME';
      console.log(`[DeliveryLabels] Label ${index + 1} changed to: PREFERRED DELIVERY TIME`);
    }
  });
  
  console.log('[DeliveryLabels] Label replacement completed');
}

// MutationObserverで#_NGC_CFAの動的読み込みを監視
function observeDeliveryOptionsContainer() {
  console.log('[DeliveryLabels] Setting up MutationObserver...');
  
  const observer = new MutationObserver((mutations) => {
    console.log('[DeliveryLabels] MutationObserver triggered, mutations:', mutations.length);
    
    let shouldCheckLabels = false;
    
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        console.log('[DeliveryLabels] ChildList mutation detected, added nodes:', mutation.addedNodes.length);
        
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            console.log('[DeliveryLabels] Element node added:', node);
            
            // #_NGC_CFA要素が追加された場合
            if (node.id === '_NGC_CFA' || node.querySelector('#_NGC_CFA')) {
              console.log('[DeliveryLabels] #_NGC_CFA element detected');
              shouldCheckLabels = true;
            }
            
            // .ngc-note-attr-field要素が追加された場合
            if (node.classList && node.classList.contains('ngc-note-attr-field')) {
              console.log('[DeliveryLabels] .ngc-note-attr-field element detected');
              shouldCheckLabels = true;
            }
            
            // .ngc-note-attr-field要素を内包する要素が追加された場合
            if (node.querySelector && node.querySelector('.ngc-note-attr-field')) {
              console.log('[DeliveryLabels] Element containing .ngc-note-attr-field detected');
              shouldCheckLabels = true;
            }
          }
        });
      }
      
      // テキストの変更も監視
      if (mutation.type === 'characterData') {
        const target = mutation.target.parentElement;
        if (target && target.tagName === 'LABEL' && target.closest('.ngc-note-attr-field')) {
          console.log('[DeliveryLabels] Label text change detected:', target);
          shouldCheckLabels = true;
        }
      }
    });
    
    if (shouldCheckLabels) {
      console.log('[DeliveryLabels] Scheduling label replacement check...');
      // 複数回の遅延実行で確実にキャッチ
      setTimeout(replaceDeliveryLabelsForEnglish, 50);
      setTimeout(replaceDeliveryLabelsForEnglish, 200);
      setTimeout(replaceDeliveryLabelsForEnglish, 500);
    }
  });

  // .p-cart__delivery-content を監視対象にする
  const cartContainer = document.querySelector('.p-cart__delivery-content') || document.body;
  console.log('[DeliveryLabels] Observer target:', cartContainer);
  
  observer.observe(cartContainer, {
    childList: true,
    subtree: true,
    characterData: true, // テキストの変更も監視
    characterDataOldValue: true
  });

  console.log('[DeliveryLabels] MutationObserver started');

  // 初回実行（既に要素が存在する場合）
  console.log('[DeliveryLabels] Running initial check...');
  replaceDeliveryLabelsForEnglish();
}

// DOM読み込み完了後に監視開始
console.log('[DeliveryLabels] Initializing delivery labels functionality...');
console.log('[DeliveryLabels] Document ready state:', document.readyState);

if (document.readyState === 'loading') {
  console.log('[DeliveryLabels] Document still loading, waiting for DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', observeDeliveryOptionsContainer);
} else {
  console.log('[DeliveryLabels] Document already loaded, starting immediately...');
  observeDeliveryOptionsContainer();
}
